/**
     * @desc 4根据盲盒ID查询盲盒历史信息NoAuth
用于：盲盒详情页下方历史列表，参数：id, count, pageSize
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/selectBoxHistory', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/selectBoxHistory', params);
}
